// extracted by mini-css-extract-plugin
export var tocTopLevel = "table-of-contents-module--toc-top-level--KCzF+";
export var tocDetails = "table-of-contents-module--toc-details--LFP-f";
export var tocTitle = "table-of-contents-module--toc-title--bD8gi";
export var active = "table-of-contents-module--active--x6hWv";